/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { campaignChannelDestroy } from '../../axios/campaignChannelDestroy'
import type {
	CampaignChannelDestroyError,
	CampaignChannelDestroyPathParams,
	CampaignChannelDestroyResponse,
} from '../../types/CampaignChannelDestroy'

export const campaignChannelDestroyMutationKey = () => [{ url: '/campaigns/:campaign/channels/:channel' }] as const

export type CampaignChannelDestroyMutationKey = ReturnType<typeof campaignChannelDestroyMutationKey>

export type CampaignChannelDestroyVariables = {
	campaign: CampaignChannelDestroyPathParams['campaign']
	channel: CampaignChannelDestroyPathParams['channel']
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/CampaignChannelController.php CampaignChannelController::destroy */
export function useCampaignChannelDestroy<TContext = unknown>(
	options?: UseMutationOptions<
		CampaignChannelDestroyResponse,
		AxiosError<CampaignChannelDestroyError>,
		CampaignChannelDestroyVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: campaignChannelDestroyMutationKey(),
		mutationFn: ({ campaign, channel }: CampaignChannelDestroyVariables) =>
			campaignChannelDestroy(campaign, channel, config).then(res => res.data),
		...options,
	})
}
